<template>
  <div class="iframe-container">
    <iframe :src="frameSrc" frameborder="0"></iframe>
  </div>
</template>

<script>
// TODO: 先写死，后续改成动态获取
const FRAME_SRC = "https://rplatform.finzfin.com/platform-front/fixed_agreement/?agreement_type=secret&pkg_type=3";

export default {
  name: "iframeContainer",

  data() {
    return {
      frameSrc: FRAME_SRC
    };
  },
  mounted() {
    console.log("iframeContainer mounted");
  }
};

</script>

<style scoped>
.iframe-container {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/ProtocolContainer/index.vue